import Blockquote from "@tiptap/extension-blockquote";
import {
  NodeViewWrapper,
  NodeViewContent,
  ReactNodeViewRenderer,
} from "@tiptap/react";

const BlockquoteView = ({ node, updateAttributes }) => {
  const { citation } = node.attrs;

  return (
    <NodeViewWrapper>
      <div className="my-6 not-prose w-fit">
        {/* Top orange border */}
        <div className="h-[3px] bg-orange-500 mb-4" />

        {/* Quote text */}
        <div className="text-[#0060C7] text-base leading-relaxed italic px-2">
          <NodeViewContent />
        </div>

        {/* Attribution */}
        <input
          type="text"
          value={citation || ""}
          onChange={(e) => updateAttributes({ citation: e.target.value })}
          placeholder="– Author name"
          className="block text-right text-[#0060C7] font-bold text-base bg-transparent border-none outline-none placeholder:text-blue-300 w-full px-2 mt-2"
        />

        {/* Bottom orange border */}
        <div className="h-[3px] bg-orange-500 mt-4" />
      </div>
    </NodeViewWrapper>
  );
};

const BlockquoteExtension = Blockquote.extend({
  addAttributes() {
    return {
      citation: {
        default: null,
        renderHTML: (attributes) => {
          if (!attributes.citation) return {};
          return { "data-citation": attributes.citation };
        },
        parseHTML: (element) =>
          element.getAttribute("data-citation") || null,
      },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(BlockquoteView);
  },

  renderHTML({ HTMLAttributes }) {
    const blockquoteStyle = [
      "display: inline-block",
      "border-top: 3px solid #f97316",
      "border-bottom: 3px solid #f97316",
      "border-left: none",
      "padding: 1rem 0.5rem",
      "margin: 1.5rem 0",
      "color: #0060C7",
      "font-style: italic",
    ].join("; ");

    return ["blockquote", { ...HTMLAttributes, style: blockquoteStyle }, 0];
  },

  parseHTML() {
    return [
      {
        tag: "blockquote",
        getAttrs(dom) {
          // Support data-citation attribute
          const dataCitation = dom.getAttribute("data-citation");
          if (dataCitation) return { citation: dataCitation };

          // Fallback: parse from <footer> element
          const footer = dom.querySelector("footer");
          if (footer) {
            const text = footer.textContent
              ?.replace(/^–\s*/, "")
              .replace(/^—\s*/, "")
              .trim();
            return { citation: text || null };
          }

          return { citation: null };
        },
      },
    ];
  },
});

export default BlockquoteExtension;
